import { reactShinyInput } from "reactR";
import React, { useState, useEffect } from "react";

import { getSelect, getInputOptions } from "./utils.jsx";

import "./www/colour_picker.css";

const ColourPickerInput = ({ configuration, value, setValue }) => {
  // --------------------- State hooks ---------------------
  const fullColours =
    configuration.colours && configuration.colours.length > 0
      ? configuration.colours
      : ["red", "orange", "yellow", "green", "blue", "purple", "pink"];
  const fullOptions =
    configuration.options && configuration.options.length > 0
      ? configuration.options
      : [];

  const [config, setConfig] = useState({
    inputs: [],
    fullColours: fullColours,
    fullOptions: fullOptions,
    options: fullOptions,
    colours: [fullColours[0]], // Start with one colour
  });

  const [inputs, setInputs] = useState([]);
  // const [fullColours, setFullColours] = useState(
  //   configuration.colours && configuration.colours.length > 0
  //     ? configuration.colours
  //     : ["red", "orange", "yellow", "green", "blue", "purple", "pink"]
  // );
  // const [fullOptions, setFullOptions] = useState(
  //   configuration.options && configuration.options.length > 0
  //     ? configuration.options
  //     : []
  // );
  // const [options, setOptions] = useState(fullOptions);
  // const [colours, setColours] = useState([fullColours[0]]); // Start with one colour

  // --------------------- Variables -----------------------

  // --------------------- Effects -------------------------

  // Initialize inputs state with value from Shiny
  useEffect(() => {
    if (value && Array.isArray(value)) {
      setConfig((prev) => ({ ...prev, inputs: value }));
    }
  }, [value]);

  // Initialize any updates to the options from configuration
  useEffect(() => {
    const selectOptions = configuration.options;
    if (
      selectOptions &&
      Array.isArray(selectOptions) &&
      selectOptions.length > 0
    ) {
      setConfig((prev) => ({ ...prev, fullOptions: selectOptions }));
    }
  }, [configuration.options]);

  // When selected items change, update colours and options
  useEffect(() => {
    const old = { ...config };
    if (
      config.inputs &&
      Array.isArray(config.inputs) &&
      config.inputs.length > 0
    ) {
      setConfig((prev) => ({
        ...prev,
        colours: old.fullColours.slice(0, config.inputs.length + 1),
        options: old.fullOptions.filter((opt) => !config.inputs.includes(opt)),
      }));
    } else {
      setConfig((prev) => ({
        ...prev,
        colours: [old.fullColours[0]],
        options: old.fullOptions,
      }));
    }
  }, [config.inputs, config.fullOptions]);

  // When inputs change, update the value sent to Shiny
  useEffect(() => {
    const selectedValues = config.fullColours.reduce((acc, key, i) => {
      acc[key] = config.inputs[i];
      return acc;
    }, {});

    setValue(selectedValues);
  }, [config.inputs]);

  // --------------------- Event handlers ------------------

  /**
   * Handles changing an item in the selected items list.
   * This not not used on the main select, but on the individual selects.
   *
   * @param {number} index    The index of the item to change.
   * @param {Object} newValue The new value to set for the item.
   * @return {void}
   */
  const handleChangeItem = (index, newValue) => {
    const updated = [...config.inputs];

    if (newValue) {
      updated[index] = newValue.value;
    } else {
      updated.splice(index, 1);
    }
    setConfig((prev) => ({ ...prev, inputs: updated }));
  };

  // --------------------- Helper functions ----------------

  // --------------------- Render logic --------------------

  return (
    <div className="colour-picker-container">
      {Array.isArray(config.colours) &&
        config.colours.map((colour, index) => {
          const selectId = `${configuration.inputId}-colour-${index}`;
          let selectedOptions = [...config.options];
          if (config.inputs[index]) {
            selectedOptions = [config.inputs[index], ...config.options];
          }
          if (index >= config.fullOptions.length) {
            return;
          }
          return (
            <div className="picker-item" key={index}>
              <div
                className="picker-colour"
                style={{ background: colour }}
              ></div>
              {getSelect(
                selectId,
                getInputOptions(selectedOptions),
                (e) => handleChangeItem(index, e),
                getInputOptions(config.inputs[index]) || null
              )}
            </div>
          );
        })}
    </div>
  );
};

reactShinyInput(
  ".colour_picker",
  "colourPicker.colour_picker",
  ColourPickerInput
);
